import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'

import en_resource from './en/resource'
import am_resource from './am/resource'

i18n.use(initReactI18next).init({
  resources: {
    en: en_resource,
    am: am_resource,
  },
  lng: 'am',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
